<template>
    <div class="range-slider">
        <div class="wrapper-box">
          <input type="number" :min="valuemin" :max="valuemax" :step="step" v-model="sliderMin" @change="onInput">
          <span>à</span>
          <input type="number" :min="valuemin" :max="valuemax" :step="step" v-model="sliderMax" @change="onInput">  
        </div>
        <div class="wrapper-range">
          <input type="range" :min="valuemin" :max="valuemax" :step="step" v-model="sliderMin" @change="onInput">
          <input type="range" :min="valuemin" :max="valuemax" :step="step" @change="onInputMax" :value="sliderMax">          
        </div>
    </div>  
</template>
<script>
export default {
    name: "DoubleRange",
    props: ['valuemin', 'valuemax', 'step'],
    data() { 
        return {
            valuea: this.valuemin, 
            valueb: this.valuemax
        };
    },
    methods: {
        //there is a bug with range input > 100 - https://github.com/vuejs/vue/issues/9515
        //to correct it we don't use a v-model and we need to set manually the sliderMax value
        onInputMax(e) {          
          this.sliderMax = e.target.value;
          this.$emit('input', this.sortedvalues);
        },
        onInput() {            
            this.$emit('input', this.sortedvalues);
        },
        reinit() {
          this.sliderMin = this.valuemin;
          this.sliderMax = this.valuemax;
        }
    },
    computed: {
        sliderMin: {
            get: function() {
                const val = parseInt(this.valuea);
                return val;
            },
            set: function(val) {
                val = parseInt(val);
                if (val > this.valueb) {
                    this.valueb = val;
                }
                this.valuea = val;
            }
        },
        sliderMax: {
            get: function() {
                const val = parseInt(this.valueb);
                return val;
            },
            set: function(val) {
                val = parseInt(val);
                if (val < this.valuea) {
                    this.valuea = val;
                }
                this.valueb = val;
            }
        },
        sortedvalues() {
            let valuea = +this.valuea, valueb = +this.valueb;
            return valuea < valueb ? [valuea, valueb] : [valueb, valuea];
        }
  }
}
</script>

<style>
.range-slider {
  padding: 0;
  margin: auto 20px;
  text-align: center;
  position: relative;
  height: 4em;
}

.range-slider .wrapper-range, .range-slider .wrapper-box {
  position: relative;
}

.range-slider .wrapper-box {
  margin-bottom: 40px;
}

.range-slider input[type=range] {
  position: absolute;
  left: 0;
  bottom: 0;
}

.range-slider input[type=number] {
    width: 70px;
    display: inline-block;
    border: 1px solid #ddd;
    text-align: center;
    font-size: 1.25em;
    -moz-appearance: textfield;
    margin: 0 5px;      
}

.range-slider input[type=number]::-webkit-outer-spin-button,
.range-slider input[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

.range-slider input[type=number]:invalid,
.range-slider input[type=number]:out-of-range {
  border: 2px solid #ff6347;
}

.range-slider input[type=range] {
  -webkit-appearance: none;
  background: transparent;
  width: 100%;
  height: 0;
}

.range-slider input[type=range]:focus {
  outline: none;
}

.range-slider input[type=range]:focus::-webkit-slider-runnable-track {
  background: #005850;
}

.range-slider input[type=range]:focus::-ms-fill-lower {
  background: #C99539;
}

.range-slider input[type=range]:focus::-ms-fill-upper {
  background: #C99539;
}

.range-slider input[type=range]::-webkit-slider-runnable-track {
  width: 100%;
  height: 10px;
  cursor: pointer;
  /*animate: 0.2s;*/
  background: #005850;
  border-radius: 5px;
  box-shadow: none;
  border: 0;
}

.range-slider input[type=range]::-moz-range-track {
  -moz-appearance: none;  
  pointer-events: auto;
  box-sizing: border-box;
	border: none;
  width: 100%;
  height: 10px;
  cursor: pointer;
  background: #005850;
  border-radius: 5px;
  box-shadow: none;
  border-width: 0;
  margin: 0;
}
.range-slider input[type=range]:last-child::-moz-range-track {
  height: 0;
  background: transparent; border:0px;
}


.range-slider input[type=range]::-webkit-slider-thumb{
  z-index: 2;
  position: relative;
  box-shadow: 0px 0px 0px #000;
  border: 1px solid #C99539;
  height: 25px;
  width: 25px;
  border-radius: 25px;
  background: #C99539;
  cursor: pointer;
  -webkit-appearance: none;
  margin-top: -7px;  
}

.range-slider input[type=range]::-moz-range-thumb{
  -moz-appearance: none;  
  pointer-events: auto;
  z-index: 2;
  position: relative;
  box-shadow: 0px 0px 0px #000;
  border: 1px solid #C99539;
  height: 25px;
  width: 25px;
  border-radius: 25px;
  background: #C99539;
  cursor: pointer;
  -webkit-appearance: none;
  margin-top: -7px;  
}
</style>